/* eslint-disable @typescript-eslint/no-extraneous-class */
export default class JudasConstant {

  /**
   * 页面cid相关
   */
  // 我的优惠券列表页-cid
  static MY_COUPON_LIST_CID = 'c_waimai_c_overseas_tcfio133'

  // 历史优惠券列表页-cid
  static HISTORY_COUPON_LIST_CID = 'c_waimai_c_overseas_dghtg0ss'

  // 提单优惠券列表页-cid
  static ORDER_CONFIRM_COUPON_LIST_CID = 'c_waimai_c_overseas_679t2429'

  // 我的券列表页-券兑换页-cid
  static MY_COUPON_PROMO_CID = 'c_sailor_c_pxuk4ie0'

  // 提单券列表页-券兑换页-cid
  static ORDER_COUPON_PROMO_CID = 'c_sailor_c_kvur78xl'

  /**
   * 我的优惠券列表相关
   */
  // 券曝光
  static MY_COUPON_COUPON_MV = 'b_waimai_c_overseas_a1xs6lzx_mv'

  // 规则弹窗入口曝光+点击
  // static MY_COUPON_COUPON_RULE_MV = 'b_waimai_c_overseas_smm0e6i3_mv'

  static MY_COUPON_COUPON_RULE_MC = 'b_waimai_c_overseas_ym9yupej_mc'

  // 规则弹窗关闭按钮点击
  static MY_COUPON_COUPON_RULE_CLOSE_MC = 'b_sailor_c_exlzt5zm_mc'

  // 历史优惠入口曝光和点击
  static MY_COUPON_HISTORY_ENTRY_MV = 'b_waimai_c_overseas_rsp7h36d_mv'

  static MY_COUPON_HISTORY_ENTRY_MC = 'b_waimai_c_overseas_rsp7h36d_mc'

  // code输入栏
  static MY_COUPON_EXCHANGE_ENTRY_MC = 'b_sailor_c_ksbpw8y6_mc'

  static MY_COUPON_EXCHANGE_TOAST_MV = 'b_sailor_c_3ofi826m_mv'

  static MY_COUPON_USE_BUTTON_MC = 'b_sailor_c_wsa1e7lj_mc'

  // 膨胀按钮mc
  static MY_COUPON_UPGRADE_BUTTON_MC = 'b_sailor_c_o7pmx2za_mc'

  // 逆膨按钮mc
  static MY_COUPON_DOWNGRADE_BUTTON_MC = 'b_sailor_c_1zzgd533_mc'

  // 膨前弹窗-mv
  static MY_COUPON_UPGRADE_MODAL_PREUPGRADE_MV = 'b_sailor_c_0oab8v5k_mv'

  // 膨前弹窗-膨胀按钮-mc
  static MY_COUPON_UPGRADE_MODAL_PREUPGRADE_MC = 'b_sailor_c_hv8f780n_mc'

  // 膨后弹窗-mv
  static MY_COUPON_UPGRADE_MODAL_POSTUPGRADE_MV = 'b_sailor_c_gn6t91eb_mv'

  /**
   * 历史优惠券列表相关
   */
  // 历史优惠券列表页-tab-mv
  static HISTORY_COUPON_LIST_TAB_MV = 'b_waimai_c_overseas_jdp3i7vy_mv'

  // 历史优惠券列表页-tab-mc
  static HISTORY_COUPON_LIST_TAB_MC = 'b_waimai_c_overseas_jdp3i7vy_mc'

  // 历史优惠券列表页-券曝光
  static HISTORY_COUPON_LIST_ITEM_MV = 'b_sailor_c_sw2pzcn9_mv'

  /**
   * 提单优惠券列表相关
   */
  // 优惠券列表页-不可用券卡片曝光
  static ORDER_CONFIRM_COUPON_UNABLE_COUPON_MV = 'b_sailor_c_m5op8xt3_mv'

  // 优惠券列表页-可用券卡片曝光和点击
  static ORDER_CONFIRM_COUPON_ENABLE_COUPON_MV = 'b_waimai_c_overseas_smm0e6i3_mv'

  static ORDER_CONFIRM_COUPON_ENABLE_COUPON_MC = 'b_waimai_c_overseas_smm0e6i3_mc'

  // 优惠券列表页-可用优惠券-服务条款和细则
  static ORDER_CONFIRM_COUPON_URLE_MV = 'b_waimai_c_overseas_g91jsy3c_mv'

  static ORDER_CONFIRM_COUPON_URLE_MC = 'b_waimai_c_overseas_g91jsy3c_mc'

  // 底部确认
  static ORDER_CONFIRM_COUPON_BOTTOM_CONFIRM_MC = 'b_waimai_c_overseas_sto5siox_mc'

  // code输入栏
  static ORDER_COUPON_EXCHANGE_ENTRY_MC = 'b_sailor_c_ksbpw8y6_mc'

  // 支付渠道确认弹窗
  static ORDER_COUPON_PAYMENT_LIMIT_DIALOG_MV = 'b_sailor_c_wgywxdo0_mv'

  static ORDER_COUPON_PAYMENT_LIMIT_DIALOG_MC = 'b_sailor_c_wgywxdo0_mc'

  // 支付渠道低版本弹窗
  static ORDER_COUPON_PAYMENT_LIMIT_OLD_VERSION_MV = 'b_sailor_c_68a7bysj_mv'

  static ORDER_COUPON_PAYMENT_LIMIT_OLD_VERSION_MC = 'b_sailor_c_68a7bysj_mc'

  // 兑换成功不可用弹窗
  static ORDER_COUPON_EXCHANGE_UNUSEABLE_MV = 'b_sailor_c_tdjq1xrg_mv'

  static ORDER_COUPON_EXCHANGE_UNUSEABLE_MC = 'b_sailor_c_tdjq1xrg_mc'

  // 首单券弹窗相关
  static ORDER_COUPON_FIRSE_LIMIT_MV = 'b_sailor_c_lj005p3z_mv'

  static ORDER_COUPON_FIRSE_LIMIT_MC = 'b_sailor_c_f70775ui_mc'

  // 搭售券包模块相关(搭售券包模块MV、搭售券包模块-券包卡片MV、搭售券包模块-券包卡片MC)
  static ORDER_COUPON_COUPONPACK_MV = 'b_sailor_c_vvmuxhcc_mv'

  static ORDER_COUPON_COUPONPACK_SUB_MV = 'b_sailor_c_0qhd7m2u_mv'

  static ORDER_COUPON_COUPONPACK_SUB_MC = 'b_sailor_c_mb1v9p34_mc'

  // 膨胀按钮mc
  static ORDER_COUPON_UPGRADE_BUTTON_MC = 'b_sailor_c_gbtvjzl2_mc'

  /**
   * 兑换券相关
   */
  // 我的/提单券列表页-券兑换页-校验失败提示-mv
  static COUPON_PROMO_FAIL_MV = 'b_sailor_c_ooe3f28p_mv'

  // 我的/提单券列表页-券兑换页-提交按钮点击-mc
  static COUPON_PROMO_COMMIT_MC = 'b_sailor_c_fs68vqyd_mc'

  /**
   *  膨胀弹窗相关
   */
  // 膨前弹窗-mv
  static ORDER_COUPON_UPGRADE_MODAL_PREUPGRADE_MV = 'b_sailor_c_pyx34iox_mv'

  // 膨前弹窗-膨胀按钮-mc
  static ORDER_COUPON_UPGRADE_MODAL_PREUPGRADE_MC = 'b_sailor_c_7qpx5zux_mc'

  // 膨后弹窗-mv
  static ORDER_COUPON_UPGRADE_MODAL_POSTUPGRADE_MV = 'b_sailor_c_8x18en3d_mv'
}
